<template>
<div>
  <newest></newest>
  <MessageContent></MessageContent>
</div>
</template>

<script>
  import Newest from "./components/newest";
  import MessageContent from "./components/messageContent";
  export default {
    name: "news",
    components: {MessageContent,Newest},
    data(){
      return{

      }
    },
    methods: {

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/news/news.vue